<template>
  <div id="CreateUnitOwnerDialog_main">
    <el-button
      type="primary"
      icon="icon-plus"
      round
      @click="$refs.householdFrame.openNotShowVirtual()"
    >
      新增區權人
    </el-button>
    <!-- v.2.20.0 -->
    <!-- <el-dialog title="新增區權人" :visible.sync="dialogVisible" @close="close" width="40%">
      <el-form :model="data" :rules="rules" ref="createUnitOwnerDialogForm" label-position="left" label-width="100px">
        <el-form-item label="戶別">{{ data.tabletName }}</el-form-item>
        <el-form-item label="區權人姓名">
          <el-input v-model="data.unitOwnerName" placeholder="請輸入區權人姓名"></el-input>
        </el-form-item>
        <el-form-item label="坪數" prop="tabletArea" required>
          <el-input
            v-model="data.tabletArea"
            type="number"
            onkeydown="javascript: return event.keyCode == 69 || event.keyCode == 189 ? false : true"
            placeholder="請輸入坪數">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false" round>取消</el-button>
        <el-button type="primary" @click="submit" round>確認</el-button>
      </span>
    </el-dialog> -->
    <HouseholdFrame
      ref="householdFrame"
      :open.sync="householdSwitch"
      @select-household="selectedHousehold"
    />
  </div>
</template>
<script>
import HouseholdFrame from '@/components/HouseholdFrame'

export default {
  components: {
    HouseholdFrame
  },
  props: {
    deleteList: Array
  },
  data () {
    return {
      dialogVisible: false,
      tabletNote: '',
      data: {
        unitOwnerName: '',
        tabletArea: ''
      },
      rules: {
        tabletArea: [
          { required: true, message: '坪數不能為空', trigger: 'change' }
        ]
      },
      householdSwitch: false
    }
  },
  methods: {
    // 選擇欲新增區權戶
    selectedHousehold (val) {
      let check = false
      this.deleteList.every(item => {
        // eslint-disable-next-line eqeqeq
        if (item.tabletName == val.TabletNote) {
          check = true
          this.householdSwitch = false
          this.$emit('deletedToCreate', item.index)
        }
      })
      console.log(check)
      if (!check) { this.getUnitOwnerId(val) }
    },
    getUnitOwnerId (val) {
      apiUnitOwnerAssembly.Register.GetUnitOwnerCardByTabletId(
        {
          AssemblyId: this.$route.query.id,
          TabletId: val.TabletId
        }
      ).then(res => {
        if (res.status === 200 && res.data) {
          this.$message.error('您新增的戶別已存在名冊中，請查找該戶別點選「編輯」')
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        if (err.response.data.title === '找不到此區權人') {
          this.householdSwitch = false
          this.$emit('createRow', val)
        }
      })
    },
    // * v2.20.0 會啟用
    // // 開起新增區權人彈窗
    // openCreatUnitOwnerDialog(tabletId, tabletNote){
    //   console.log('開起新增區權人彈窗')
    //   this.dialogVisible = true
    //   this.data.tabletId = tabletId
    //   this.data.tabletName = tabletNote
    //   this.$nextTick(() => {
    //     this.$refs.createUnitOwnerDialogForm.resetFields()
    //   })
    // },
    // submit(){
    //   this.$refs.createUnitOwnerDialogForm.validate((valid) => {
    //     if(!valid){
    //       return false
    //     }else{
    //       let requestData = {
    //         assemblyId: this.$route.params.id || this.$route.query.id,
    //         addUnitOwnerDto: this.data
    //       }
    //       apiUnitOwnerAssembly.UnitOwner.AddUnitOwner(
    //         requestData
    //       ).then(res =>{
    //         console.log(res)
    //         if(res.status == 200){
    //           this.$message({
    //             message: '新增區權戶資料成功！',
    //             type: 'success'
    //           })
    //           this.dialogVisible = false
    //           this.$emit('getListData')
    //         }
    //       }).catch((err)=>{
    //         console.log('錯誤訊息：',err.response)
    //         if(err.response.status >= 400){
    //           this.$message({
    //             message: '新增區權戶資料失敗',
    //             type: 'warning'
    //           })
    //           this.dialogVisible = false
    //         }
    //       })
    //     }
    //   })
    // },
    close () {
      this.data = {
        unitOwnerName: '',
        tabletArea: '',
        tabletId: '',
        tabletName: ''
      }
    }
  }
}
</script>
<style lang="sass" scoped>
#CreateUnitOwnerDialog_main
  display: inline-block
  margin-right: 10px
  ::v-deep .el-dialog
    +basicDialog
    min-width: 400px
    .el-dialog__footer
      text-align: center
    .el-form
      text-align: left
      .el-form-item
        .el-form-item__label
          font-weight: bold
          margin-right: 0
        &.is-required
          .el-form-item__label
            position: relative
            +redStar
      .el-input
        .el-input__inner
          text-align: left
          line-height: 1px
        input::-webkit-outer-spin-button,input::-webkit-inner-spin-button
          -webkit-appearance: none
          margin: 0
</style>
